import { atom } from "jotai";
import type React from "react";
import type { BackButtonHookInterface } from "../hooks/useBackButton";

export type VisibleAction = "profile" | "notification" | "search" | "cart" | "drawer" | React.ReactElement;

export interface HeaderStoreInterface {
  drawerOpen?: boolean;
  visible?: boolean;
  visibleActions: VisibleAction[];
  title?: string;
  closeButton?: { url?: string; modal?: JSX.Element };
  backButton?: BackButtonHookInterface;
  customActionComponent?: React.ReactNode;
}

export const initialHeader = {
  drawerOpen: false,
  visible: true,
  visibleActions: [] as VisibleAction[],
  backButton: undefined,
  customActionComponent: undefined,
  title: undefined,
  closeButton: undefined,
};

export const HeaderStore = atom<HeaderStoreInterface>(initialHeader);
